import React from 'react';
import { Card, Badge, Button } from 'react-bootstrap';
import { BiEdit, BiTrash, BiLinkAlt } from 'react-icons/bi';
import { FaBoxOpen } from 'react-icons/fa';
import { css } from 'twin.macro';
import styled from '@emotion/styled';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { ActionStyles } from '@/components/Admin/reusableStyles';

const BucketContainer = styled.div`
    margin-bottom: 1rem;
    margin-right: 1rem;
    margin-top: 2rem;
`;

const BucketCard = ({ bucket, index, stats, onEdit, onAssignPlan, onDelete, onViewStaff }) => {
    return (
        <BucketContainer>
            <Card
                css={css`
                    width: 300px;
                    border-top: 5px solid ${bucket.color || '#3498db'};
                    min-height: 300px;
                    display: flex;
                    flex-direction: column;
                    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
                `}
            >
                <Card.Body className="d-flex flex-column" style={{ flex: 1 }}>
                    <div className="div1" style={{ marginBottom: '1rem' }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">
                                <FaBoxOpen
                                    className="mr-2"
                                    css={css`
                                        color: ${bucket.color || '#3498db'};
                                    `}
                                />
                                {bucket.name}
                            </h5>
                            <Badge variant="secondary">{stats?.staffCount || 0} Staff</Badge>
                        </div>

                        <p className="text-muted small mb-2">{bucket.description}</p>

                        {stats && (
                            <div className="mb-3">
                                <small className="text-muted">
                                    Avg. time in bucket: {stats.averageDaysInBucket} days
                                </small>
                            </div>
                        )}
                        {bucket.activityPlan && (
                            <div className="mb-3 border border-1 p-2">
                                <span>
                                    <span className="badge badge-info mr-2">Activity Plan:</span>
                                    <br />
                                    <small className="text-muted">{bucket.activityPlan.name}</small>
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="div2" style={{ marginTop: 'auto' }}>
                        <div className="mb-2 d-flex justify-content-center">
                            <ActionStyles>
                                <BootstrapToolTip text={'Edit Bucket'}>
                                    <BiEdit className="icon edit" onClick={onEdit} />
                                </BootstrapToolTip>

                                <BootstrapToolTip text={'Assign Activity Plan'}>
                                    <BiLinkAlt className="icon link" onClick={onAssignPlan} />
                                </BootstrapToolTip>

                                <BootstrapToolTip text={'Delete Bucket'}>
                                    <BiTrash className="icon delete" onClick={() => onDelete(bucket)} />
                                </BootstrapToolTip>
                            </ActionStyles>
                        </div>

                        <Button variant="outline-primary" size="lg" className="w-100" onClick={onViewStaff}>
                            View Staff ({stats?.staffCount || 0})
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </BucketContainer>
    );
};

export default BucketCard;
